<template>
  <div>
    <template v-if="loader">
      <mds-loader class="loader" />
    </template>
    <template v-else>
      <performance-report-options
        v-if="isPerformanceReport"
        :performance-report-parameters="parametersStepInfo"
        :editedFeed="editedFeed"
        v-on="$listeners"
      />
      <div v-else>
        <investment-options
          :parameter-name="NOTEBOOK_PARAMETER_NAMES.investment_item"
          :investments="investmentItems"
          :source-type="sourceType"
          :editedFeed="editedFeed"
          @investmentChange="investmentChange"
        />
        <template v-if="dataSetType === 'basic'">
          <dataset-options
            :parameter-name="NOTEBOOK_PARAMETER_NAMES.data_set"
            :investments="datasetItems"
            :selected-investment="investment"
            :source-type="sourceType"
            :binding-dataset="bindingDataset"
            :investment-value-change="investmentValueChange"
            :editedFeed="editedFeed"
            :isLoadingDataset="loadingDataset"
            @datasetChange="datasetChange"
          />
        </template>
        <template v-else-if="dataSetType === 'holdings'">
          <holdings-dataset-options />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MdsLoader from '@mds/loader'
import isEmpty from 'lodash/isEmpty'
import PerformanceReportOptions from '@/components/schedulerModal/schedulerSteps/helpers/PerformanceReportOptions'
import InvestmentOptions from '@/components/schedulerModal/schedulerSteps/helpers/InvestmentOptions'
import DatasetOptions from '@/components/schedulerModal/schedulerSteps/helpers/DatasetOptions'
import HoldingsDatasetOptions from '@/components/schedulerModal/schedulerSteps/helpers/HoldingsDatasetOptions'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'
import {
  NOTEBOOK_PARAMETER_NAMES,
  SOURCE_TYPES,
} from '@/components/schedulerModal/config/constants'

export default {
  name: 'ParameterStep',
  components: {
    InvestmentOptions,
    DatasetOptions,
    PerformanceReportOptions,
    HoldingsDatasetOptions,
    MdsLoader,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    sourceType: {
      type: String,
      default: '',
    },
    dataSetType: {
      type: String,
      default: '',
    },
    parametersStepInfo: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
  },
  data() {
    return {
      defaultConfig,
      NOTEBOOK_PARAMETER_NAMES,
      bindingDataset: undefined,
      loadingDataset: false,
      investment: '',
      investmentValueChange: false,
      responseStatus: undefined,
    }
  },
  watch: {
    investment(value, oldValue) {
      if (!isEmpty(oldValue) && value !== oldValue) {
        this.investmentValueChange = true
      }
      this.getBindingDataset(value)
    },
  },
  computed: {
    ...mapState({
      cache: (state) => state.cache.cache,
    }),
    editedFeed() {
      return this.cache.editedFeed
    },
    loader() {
      return this.cache.parametersLoader
    },
    isPerformanceReport() {
      return this.sourceType === NOTEBOOK_PARAMETER_NAMES.performance_report
    },
    investmentType() {
      return this.sourceType === SOURCE_TYPES.list ? 'list' : 'screen'
    },
    investmentItems() {
      const investments = Object.values(this.parametersStepInfo).find(
        (parameter) =>
          parameter.name === NOTEBOOK_PARAMETER_NAMES.investment_item
      )

      if (investments) {
        return investments.options
      }
      return {}
    },
    datasetItems() {
      const datasets = Object.values(this.parametersStepInfo).find(
        (parameter) => parameter.name === NOTEBOOK_PARAMETER_NAMES.data_set
      )

      if (datasets) {
        return datasets.options
      }
      return {}
    },
  },
  methods: {
    async investmentChange(investmentId) {
      if (!investmentId) {
        return
      }

      this.investment = investmentId
      this.$emit('input', { investment_item: this.investment })
    },
    datasetChange(dataset) {
      if (!dataset) {
        return
      }

      const [datasetId] = dataset
      this.$emit('input', { data_set: datasetId })
    },
    async getBindingDataset(investmentId) {
      this.loadingDataset = true

      const bindingDataset = await this.$store.dispatch('updateDataset', {
        type: this.investmentType,
        investmentId: investmentId,
      })

      this.bindingDataset = bindingDataset
      this.loadingDataset = false
    },
    reload() {
      this.$emit('get-parameters', this.sourceType)
    },
  },
}
</script>

<style lang="scss" scoped>
.parameters-step {
  &__error-container {
    display: flex;
    justify-content: center;
  }
}
</style>
